import { ActionWithErrorBadge } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';

import { usePayoffField } from './usePayoffField';

const Payoff = () => {
    const { label, errorBadgeEntity, onLabelActivate, onLabelKeyDown, inputProps } = usePayoffField();

    return (
        <>
            <label
                data-testid={`payoff-input-label`}
                className="base-deal-activity-control-custom-label"
                onClick={onLabelActivate}
                onKeyDown={onLabelKeyDown}
                tabIndex={0}
                role="button"
            >
                {' '}
                <ActionWithErrorBadge entityName={errorBadgeEntity} xOffset="-2px" yOffset="1px">
                    {label}
                </ActionWithErrorBadge>
                <ChevronRightIcon fontSize={10} />
            </label>
            <NumericInput {...inputProps} displayLabel={false} />
        </>
    );
};

export default Payoff;
